import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    organisation: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="w-full py-20 md:py-24 relative" style={{
    backgroundColor: '#09090B'
  }} data-id="element-142">
      <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center mb-12" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight font-heading" data-id="element-145">
            Vous organisez des événements. Parlons-en.
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-146">
          <div data-id="element-147">
            <label htmlFor="nom" className="block text-sm font-medium text-white/70 mb-2" data-id="element-148">
              Nom *
            </label>
            <input type="text" id="nom" name="nom" required value={formData.nom} onChange={handleChange} className="w-full px-4 py-3 bg-white/[0.05] border border-white/[0.12] rounded-lg text-white placeholder-white/30 focus:outline-none focus:border-cyan-500/50 focus:ring-2 focus:ring-cyan-500/20 transition-colors" placeholder="Votre nom" data-id="element-149" />
          </div>

          <div data-id="element-150">
            <label htmlFor="email" className="block text-sm font-medium text-white/70 mb-2" data-id="element-151">
              Email *
            </label>
            <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white/[0.05] border border-white/[0.12] rounded-lg text-white placeholder-white/30 focus:outline-none focus:border-cyan-500/50 focus:ring-2 focus:ring-cyan-500/20 transition-colors" placeholder="votre@email.com" data-id="element-152" />
          </div>

          <div data-id="element-153">
            <label htmlFor="organisation" className="block text-sm font-medium text-white/70 mb-2" data-id="element-154">
              Organisation *
            </label>
            <input type="text" id="organisation" name="organisation" required value={formData.organisation} onChange={handleChange} className="w-full px-4 py-3 bg-white/[0.05] border border-white/[0.12] rounded-lg text-white placeholder-white/30 focus:outline-none focus:border-cyan-500/50 focus:ring-2 focus:ring-cyan-500/20 transition-colors" placeholder="Votre organisation" data-id="element-155" />
          </div>

          <div data-id="element-156">
            <label htmlFor="message" className="block text-sm font-medium text-white/70 mb-2" data-id="element-157">
              Message (optionnel)
            </label>
            <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 bg-white/[0.05] border border-white/[0.12] rounded-lg text-white placeholder-white/30 focus:outline-none focus:border-cyan-500/50 focus:ring-2 focus:ring-cyan-500/20 transition-colors resize-none" placeholder="Parlez-nous de vos événements..." data-id="element-158" />
          </div>

          <Button type="submit" size="lg" className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0 shadow-lg" data-id="element-159">
            Envoyer
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-160" />
          </Button>
        </form>
      </div>
    </section>;
}